//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuidv4 } from 'uuid'
import TopScreen from '~/components/TopScreen.vue'
import EventPost from '~/components/events/event-post.vue'
// import Newsletter from '~/components/events/Newsletter.vue'
import EventsBottom from '~/components/events/event-bottom.vue'
import APIloading from '~/components/common/APILoading.vue'
import APIFailed from '~/components/common/APIFailed.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import { esaEncryptData, esaDecryptData } from '~/plugins/secret'

export default {
  components: {
    TopScreen,
    EventPost,
    // Newsletter,
    EventsBottom,
    APIloading,
    APIFailed,
    FooterTop
  },
  data () {
    return {
      faq: [],
      fetched: false,
      fetchError: false,
      events: [
        // {
        //   id: 4,
        //   startDate: '2023-04-12',
        //   endDate: '2023-04-15',
        //   place: 'Hong Kong',
        //   title: 'Web3 Festival HONG KONG',
        //   description:
        //     'We will be waiting for you at the Hong Kong Web 3 Festival 2023!<br>Come meet our team at booth G21!<br>Your presence would be awesome!',
        //   img: require('@/assets/img/events/event-4.jpg'),
        //   link: 'https://www.linkedin.com/company/pagsmile',
        //   showBooking: false
        // },
        // {
        //   id: 3,
        //   startDate: '2023-03-07',
        //   endDate: '2023-03-09',
        //   place: 'Berlin',
        //   title: 'ITB Berlin',
        //   description:
        //     "Come meet our team and learn more about our solutions! We'll be waiting for you at Hall 6.1, 153 , from March 7 to 9!",
        //   img: require('@/assets/img/events/event-3.jpg'),
        //   link: 'https://www.linkedin.com/company/pagsmile',
        //   showBooking: false,
        //   pastEvent: true
        // },
        // {
        //   id: 2,
        //   startDate: '2023-02-07',
        //   endDate: '2023-02-09',
        //   place: 'London',
        //   title: 'Ice London',
        //   description:
        //     "Come meet our team and learn more about our solutions! We'll be waiting for you at booth N9-261, from February 7 to 9!",
        //   img: require('@/assets/img/events/event-2.jpg'),
        //   link: 'https://www.linkedin.com/company/pagsmile',
        //   showBooking: false,
        //   pastEvent: true
        // },
        // {
        //   id: 1,
        //   startDate: '2022-06-07',
        //   endDate: '2022-06-09',
        //   place: 'Cyprus',
        //   title: 'iFX Cyprus',
        //   description:
        //     'We’ll be at iFX Cyprus in person. Book a 1-on-1 with our specialists to find out how we can add more payment options to your checkout.',
        //   img: require('@/assets/img/events/event-1.jpg'),
        //   showBooking: false,
        //   pastEvent: true
        // }
      ],
      currentPage: 1,
      perPage: 9,
      total: 0,
      nextEvents: [],
      pastEvents: []
    }
  },
  async fetch () {
    if (!this.$encrypt) {
      return
    }
    try {
      const uuid = uuidv4().replace(/-/g, '')
      const eventResponse = await fetch(
        `${process.env.APIURL}/website/common/event/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            key: this.$encrypt(uuid),
            data: esaEncryptData(
              JSON.stringify({
                page_size: this.perPage,
                page_num: this.currentPage
              }),
              uuid
            )
          })
        }
      )
        .then(res => res.json())
        .catch(function (e) {
          console.log(e)
        })
      const { data, key } = eventResponse
      const preResult = esaDecryptData(data, this.$decrypt(key))
      const events = JSON.parse(preResult).list
      this.total = JSON.parse(preResult).total
      this.fetched = true

      const eventList = events.map((event, index) => {
        const startDate = event.start_time.split('T')[0]
        const endDate = event.end_time.split('T')[0]
        const { id, location: place, title, description, thumbnail } = event
        const newEvent = {
          id: Number(id),
          startDate,
          endDate,
          place,
          title,
          description,
          img: thumbnail,
          // img: require('@/assets/img/events/event-4.jpg'),
          link: '',
          pastEvent: true,
          showBooking: false
        }
        // if (this.currentPage === 1 && index === 0) {
        //   newEvent.pastEvent = false
        // }
        if (this.currentPage === 1 && index === 0) {
          newEvent.showBooking = true
        }
        return newEvent
      })
      this.events = this.events.concat(eventList)

      this.nextEvents = []
      this.pastEvents = []
      this.events.forEach((event) => {
        const endDateTime = new Date(`${event.endDate} 23:59:59`).getTime()
        const nowTime = new Date().getTime()
        if (nowTime <= endDateTime) {
          event.pastEvent = false
          this.nextEvents.push(event)
        } else {
          this.pastEvents.push(event)
        }
      })
      this.nextEvents = this.nextEvents.reverse()
    } catch (err) {
      console.log('err', err)
      this.fetched = true
      this.fetchError = true
    }
  },
  // fetchOnServer: false,
  head () {
    return {
      title: this.$t('header-menu-events').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  mounted () {
    this.clientFetch()
  },
  methods: {
    clientFetch () {
      this.$fetch()
    },
    loadMoreEvents () {
      this.currentPage += 1
      this.$fetch()
    }
  }
}
